const mergeTags = (props) => {
  const mergeTagsObj = {};
  for (const prop of props) {
    let value = prop.pattern;
    if (prop.key === 'unsubscribeLink') {
      value = `<a href="${prop.pattern}">Unsubscribe</a>`;
    }

    if (prop.key === 'subscriptionManagementLink') {
      value = `<a href="${prop.pattern}">Subscription preferences</a>`;
    }

    if (prop.key === 'subscribeLink') {
      value = `<a href="${prop.pattern}">Subscribe</a>`;
    }

    if (prop.key === 'viewInBrowserLink') {
      value = `Having trouble viewing this message? <a href="${prop.pattern}">Open in your browser.</a>`;
    }

    mergeTagsObj[prop.key] = {
      name: prop.label,
      value,
    };
  }

  return mergeTagsObj;
};

export default mergeTags;
